import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { ALLOWED_AUTH_DOMAINS, DISALLOWED_AUTH_PATH } from 'constants/urls.const';
import { isNull } from 'helpers/nullCheck';
import { throwError } from 'rxjs';
import { USE_AUTH } from './tokens';

export const exceptionInterceptor: HttpInterceptorFn = (req, next) => {
	if (isNull(req?.url)) {
		return throwError(
			() =>
				new HttpErrorResponse({
					status: 404,
					statusText: 'Invalid request URL',
				}),
		);
	}

	if (requiresAuth(req.url)) return next(req);

	return next(req.clone({ context: req.context.set(USE_AUTH, false) }));
};

function requiresAuth(url: string): boolean {
	try {
		const { hostname, pathname } = new URL(url);
		const enableAuthOnDomain = ALLOWED_AUTH_DOMAINS.includes(hostname);
		const enableAuthOnPath = !DISALLOWED_AUTH_PATH.includes(pathname);

		if (enableAuthOnDomain && enableAuthOnPath) return true;

		return false;
	} catch {
		return false;
	}
}
